import { render } from "./HomeSidebar.vue?vue&type=template&id=4c2ad4c8&scoped=true"
import script from "./HomeSidebar.vue?vue&type=script&lang=js"
export * from "./HomeSidebar.vue?vue&type=script&lang=js"

import "./HomeSidebar.vue?vue&type=style&index=0&id=4c2ad4c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2ad4c8"]])

export default __exports__